export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// 返回本地登入頁面
export const getLoginUrl = () => {
  return "/login";
};

// 用於登入後重定向的首頁
export const getHomeUrl = () => {
  return "/";
};
